import { permissionManager } from "../PermissionManager/PermissionManager";

export const HOME_SNAPSHOT = 'snapshot-button';

export const HOME_PRINT = 'print-button';

export const HOME_NAVIGATE_TO_PREVIOUS_PAGE = 'goto-prev-page';
export const HOME_NAVIGATE_TO_NEXT_PAGE = 'goto-next-page';
export const HOME_GO_TO_PAGE = 'gotopage-input';

export const HOME_VIEW_SIZE = 'editable-zoom-dropdown';
export const HOME_FITPAGE = 'editable-zoom-dropdown-fitpage'
export const HOME_FITWIDTH = 'editable-zoom-dropdown-fitwidth'
export const HOME_FITVISIBLE = 'editable-zoom-dropdown-fitvisible'
export const HOME_ZOOM_IN = 'zoom-out';
export const HOME_ZOOM_OUT = 'zoom-in';

export const HOME_CHANGE_MODE = 'change-mode';

export const HOME_SINGLE_PAGE = 'single-page';
export const HOME_CONTINUOUS = 'continuous-page';
export const HOME_FACING = 'facing-page';
export const HOME_CONTINUOUS_FACING = 'continuous-facing-page';
export const HOME_H_CONTINUOUS = 'h-continuous-button';
export const HOME_LOUPE = 'loupe-button';
export const HOME_MARQUEE = 'marquee-button';
export const HOME_BACK_TO_GETTING_STARTED = 'home-back-to-getting-started'
export const SEPARATE_COVER_PAGE = 'separate-cover-page';
export const HOME_ALL_LIST = [
    HOME_SNAPSHOT,
    HOME_PRINT,
    HOME_NAVIGATE_TO_PREVIOUS_PAGE,
    HOME_NAVIGATE_TO_NEXT_PAGE,
    HOME_GO_TO_PAGE,

    HOME_VIEW_SIZE,
    HOME_ZOOM_IN,
    HOME_ZOOM_OUT,
    HOME_FITPAGE,
    HOME_FITWIDTH,
    HOME_FITVISIBLE,

    HOME_SINGLE_PAGE,
    HOME_CONTINUOUS,
    HOME_FACING,
    HOME_CONTINUOUS_FACING,
    HOME_H_CONTINUOUS,

    HOME_LOUPE,
    HOME_MARQUEE,
    HOME_BACK_TO_GETTING_STARTED,
    SEPARATE_COVER_PAGE
];

// now, all are free in home
export const HOME_PREMIUM_BTNS = [

];

permissionManager.registerOnlineFeatures([
  HOME_SNAPSHOT
])